import React from 'react';
import Typography from '@digital-hig/mui/dist/Typography';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import Grid from '@mui/material/Grid';
import Skeleton from 'react-loading-skeleton';
import HTML from '../components/html';
import VideoPlayer from '../components/videoPlayer';
import EduResDownloads from './eduResDownloads';
import { ITEM_TYPE_VIDEO, ITEM_TYPE_HTML } from './constants';

const EducatorResources = ({
  showLoader, data, sectionRef, sectionId,
}) => (
  <RootElement ref={sectionRef} data-id={sectionId}>
    {showLoader ? <Skeleton height={72} />
      : (
        <>
          {(data?.content?.length !== 0 || data?.downloads?.length !== 0)
             && (
               <>
                 <Grid>
                   <Typography component="h2" variant="headline-medium">Teaching supplements</Typography>
                   {data?.content?.map((res) => {
                     switch (res?.type) {
                     case ITEM_TYPE_VIDEO:
                       return (
                         <Grid key={res?.sys?.id}>
                           <VideoPlayer
                             content={res}
                             renderTranscript={false}
                           />
                         </Grid>
                       );
                     case ITEM_TYPE_HTML:
                       return (
                         <Grid key={res?.sys?.id} className="htmlContent">
                           <HTML content={res} />
                         </Grid>
                       );
                     default:
                       return <></>;
                     }
                   })}
                 </Grid>
                 <EduResDownloads
                   downloads={data?.downloads || []}
                   btnLabel="Download all teaching supplements"
                   title="Download teaching supplements:"
                   analyticsPrefix="teachingSupplements"
                 />
               </>
             )}
        </>
      )}
  </RootElement>
);

const RootElement = styled.div`
    margin-bottom: 65px;
  
    .htmlContent p {
      margin: revert;
    }
    .download-resource-block {
      border: 2px solid rgb(249, 249, 249);
      border-radius: 8px;
      padding: 16px;
      margin-bottom: 16px;
      margin-top: 16px;

      > div {
        padding-left: 0;
      }
      ul{
        padding-left: 0;
        list-style: none;
        line-height: 2em;
      }

      p{
        font-weight: bold;
      }
    }
`;

EducatorResources.propTypes = {
  showLoader: PropTypes.bool,
  sectionRef: PropTypes.shape({}).isRequired,
  sectionId: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(),
};

EducatorResources.defaultProps = {
  showLoader: false,
  data: [],
};

export default React.memo(EducatorResources);
